const TYPE = (exports.types = {
  ANY: "ANY",
  FPC: "FPC",
  GAR: "GAR",
  OBL: "OBL",
  OTH: "OTH",
  RPC: "RPC",
});

exports.names = {
  [TYPE.ANY]: "",
  [TYPE.FPC]: "Front Porch",
  [TYPE.GAR]: "Garage",
  [TYPE.OBL]: "Shed / Outbuilding",
  [TYPE.OTH]: "Other",
  [TYPE.RPC]: "Rear Porch",
};
